<template>
    <main>
                    <v-form ref="form">
                <v-row >
                    <v-col>
                        <v-text-field
                        v-model="fname"
                        :rules="nameRules"
                        label="Förnamn"
                        outlined
                        required>
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                        v-model="lname"
                        :rules="nameRules"
                        label="Efternamn"
                        required
                        outlined>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-text-field
                    v-model="fname"
                    :rules="nameRules"
                    label="Förnamn"
                    required
                    class="hidden-md-and-up"
                    outlined
                ></v-text-field>
                <v-text-field
                    v-model="lname"
                    :rules="nameRules"
                    label="Efternamn"
                    required
                    class="hidden-md-and-up"
                    outlined
                ></v-text-field>
                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Din mail"
                    required
                    outlined
                ></v-text-field>

                <v-text-field
                    v-model="password"
                    type="password"
                    :rules="passRules"
                    label="Lösenord"
                    required
                    outlined
                ></v-text-field>

                <v-text-field
                    v-model="cnfpass"
                    type="password"
                    label="Bekräfta lösenord"
                    :rules="[v => v === password || 'Lösenord matchar inte']"
                    required
                    outlined
                ></v-text-field>

                <sociallogin />
                <v-checkbox
                    label="Jag accepterar villkor"
                    :rules="[v => v || 'Vänligen acceptera villkoren']"
                />
                <alert />
                <v-btn
                    block
                    color="success my-3"
                    v-show="!createmeeting"
                    v-on:click="submit"
                    :loading="loading"
                >
                    Överlämna
                </v-btn>

                <v-btn
                    v-show="!createmeeting"
                    v-on:click="reset"
                    block
                >
                    Återställa
                </v-btn>
            </v-form>
    </main>
</template>

<script>
import store from "../../store";
import sociallogin from "./sociallogin";
import alert from "../layout/alert";
export default {
    components: {
        sociallogin,
        alert
    },
    store: store,
    props: ["createmeeting"],
    data: () => ({
        isActive: false,
        loading: false,
        valid: false,
        fname: "",
        lname: "",
        nameRules: [v => !!v || "Ditt namn krävs"],
        email: "",
        cnfpass: "",
        emailRules: [
            v => !!v || "Din mail krävs",
            v => /.+@.+\..+/.test(v) || "Ange giltigt e-postmeddelande"
        ],
        select: null,
        password: "",
        passRules: [
            v => !!v || "lösenord krävs",
            v => v.length >= 8 || "Lösenordet måste bestå av minst 8 tecken"
        ]
    }),
    created: function() {
        this.email = this.$store.state.email;
        if (this.$store.state.isLoggedIn && !this.createmeeting)
            this.$router.replace("/dashboard");
    },
    methods: {
        validate() {
            this.$refs.form.validate();
        },
        reset() {
            this.$refs.form.reset();
            this.loading = false;
        },
        async submit() {
            this.loading = true;
            await this.validate();
            let bodyFormData = new FormData();
            bodyFormData.set("first_name", this.fname);
            bodyFormData.set("last_name", this.lname);
            bodyFormData.set("email", this.email);
            bodyFormData.set("password", this.password);
            bodyFormData.set("password", this.password);
            bodyFormData.set("c_password", this.cnfpass);
            bodyFormData.set("role", "user");
            const config = {
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };

            if (this.$refs.form.validate()) {
                await this.$store
                    .dispatch("register", config)
                    .then(() => (this.loading = false))
                    .catch(() => {
                        this.isLoading = false;
                    });
                if (this.createmeeting) this.loading = false;
                else this.$router.replace("/dashboard");
            } else {
                this.$store.state.showAlert = true;
                this.$store.state.alertMsg = "Fyll i lämplig information";
                this.$store.state.alertType = "error";
                this.loading = false;
            }
        }
    }
};
</script>
